import React from 'react';
import './Stub.css';

function AbstractArtGallery() {
  return (
    <div className="stub-page">
      <h1>Gallery</h1>
      <p>Coming soon.</p>
    </div>
  );
}

export default AbstractArtGallery;
